/**
 * Created by koqiui on 2017-04-09.
 */
import { Utils } from '../../app.base'
import { MsgBox, Vue } from '../../app.vues';

import devcApi from '../../api/devc';

import SwbDeviceMaintPlanOnServicerAdd from './DeviceMaintPlanOnServicerAdd';
import SwbDeviceMaintPlanOnServicerAddBatch from './DeviceMaintPlanOnServicerAddBatch';
import SwbDeviceMaintPlanAdd from './DeviceMaintPlanAdd';
import SwbDeviceMaintPlanEdit from './DeviceMaintPlanEdit';
import SwbDeviceMaintPlanDetail from './DeviceMaintPlanDetail';
import SwbShopDeviceIoRecordDetail from './ShopDeviceIoRecordDetail';
import SwbShopDeviceEditInfo from './ShopDeviceEditInfo';
import SwbAssetQuickOption from './AssetQuickOption';
import SwbAssetCaseRecord from './AssetCaseRecord';
import SwbPlanYqInfo from './PlanYqInfo';
import SwbPlanYqInfoForBatch from './PlanYqInfoForBatch';
Vue.regist(SwbDeviceMaintPlanOnServicerAdd);
Vue.regist(SwbDeviceMaintPlanOnServicerAddBatch);
Vue.regist(SwbDeviceMaintPlanAdd);
Vue.regist(SwbDeviceMaintPlanEdit);
Vue.regist(SwbDeviceMaintPlanDetail);
Vue.regist(SwbShopDeviceIoRecordDetail);
Vue.regist(SwbShopDeviceEditInfo);
Vue.regist(SwbAssetQuickOption);
Vue.regist(SwbAssetCaseRecord);
Vue.regist(SwbPlanYqInfo);
Vue.regist(SwbPlanYqInfoForBatch);

// 资产折旧计算
import SwbAssetDeprComp from './AssetDeprComp';
Vue.regist(SwbAssetDeprComp);

// 设备保养计划dlg - [一个服务商一个保养计划]
export function showDeviceMainPlanForOneServicerBatchDialog(dlgArgs, callback, thisArg) {
    let theDlg = Vue.$showDialog({
        title: "资产保养计划 - 新增",
        width: 1300,
        height: 900,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-device-maint-plan-for-oneServicer-add-batch :filter="filter" ref="swb_device_maint_plan_for_oneServicer_add"></swb-device-maint-plan-for-oneServicer-add-batch>',
        data: {
            filter: dlgArgs
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_device_maint_plan_for_oneServicer_add.getDlgResult();
            if(result != null && result.type == 'info') {
                let deviceMaintPlan = result.data;
                let devcGroupId = deviceMaintPlan.devcGroupId || null;
                if(!Utils.isNoB(devcGroupId) && Array.isArray(devcGroupId)) {
                    deviceMaintPlan.devcGroupId = JSON.encode(devcGroupId);
                }
                //
                let theLoad = MsgBox.loading();
                devcApi.saveDeviceMaintPlanForOneServicerBatch(deviceMaintPlan, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        callback(theDlg);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

export function showDeviceMainPlanForOneServicerDialog(dlgArgs, callback, thisArg) {
    let theDlg = Vue.$showDialog({
        title: "资产保养计划 - 编辑",
        width: 1300,
        height: 900,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-device-maint-plan-for-oneServicer-add :filter="filter" ref="swb_device_maint_plan_for_oneServicer_add"></swb-device-maint-plan-for-oneServicer-add>',
        data: {
            filter: dlgArgs
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_device_maint_plan_for_oneServicer_add.getDlgResult();
            if(result.type == 'info') {
                let deviceMaintPlan = result.data;
                //
                let theLoad = MsgBox.loading();
                devcApi.updateDeviceMaintPlanForPage(deviceMaintPlan, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        callback(theDlg);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

// 设备保养计划dlg
export function showDeviceMainPlanDialog(dlgArgs, callback, thisArg) {
    let comName = dlgArgs.retailerShopName || null;
    let theDlg = Vue.$showDialog({
        title: "【" + comName + "】-资产保养计划 - 新增",
        width: 1300,
        height: 900,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-device-maint-plan-add :filter="filter" ref="swb_device_maint_plan_add"></swb-device-maint-plan-add>',
        data: {
            filter: dlgArgs
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_device_maint_plan_add.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let deviceMaintPlan = result.data;
                    let theLoad = MsgBox.loading();
                    devcApi.saveDeviceMaintPlan(deviceMaintPlan, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            callback(theDlg);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        }
    });
}

// 设备保养计划详情dlg
export function showDeviceMainPlanDetailDialog(id, callback, thisArg) {
    let theDlg = Vue.$showDialog({
        title: "资产保养计划 - 详情",
        width: 1200,
        height: 800,
        cancelVisible: true,
        cancelText: '关闭',
        okVisible: false,
        template: '<swb-device-maint-plan-detail :id="id" ref="swb_device_maint_plan_detail"></swb-device-maint-plan-detail>',
        data: {
            id: id
        }
    });
}

// （零售）店设备出入库记录详情
export function showShopDeviceIoRecordDetailDlg(id, title) {
    let assetTitle = title != null ? title : '资产出入库记录 - 详情';
    Vue.$showDialog({
        title: assetTitle,
        width: 1000,
        height: 850,
        cancelVisible: true,
        cancelText: '关闭',
        okVisible: false,
        template: '<swb-shop-device-io-record-detail :id="id" ref="swb_shop_device_io_record_detail"></swb-shop-device-io-record-detail>',
        data: {
            id: id
        },
        okClicked: function () {
        }
    });
}

// 设置要求时间信息
export function setPlanYqInfoDlg(params, callback) {
    let theDlg = Vue.$showDialog({
        title: "工单截止要求 - 设置",
        width: 500,
        height: 350,
        cancelVisible: true,
        cancelText: '关闭',
        template: '<swb-plan-yq-info :planType="planType" :viewFlag="viewFlag" :cronFlag="cronFlag" :theDateTime="theShoptheDateTime" ref="swb_plan_yq_info"></swb-plan-yq-info>',
        data: {
            planType: params.planType,
            viewFlag: params.viewFlag,
            cronFlag: params.cronFlag,
            theShoptheDateTime: params.theDateTime
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_plan_yq_info.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

// 设置要求时间信息
export function setPlanYqInfoForBatchDlg(params, callback) {
    let planType = params.planType;
    let theDlg = Vue.$showDialog({
        title: planType + "计划 - 设置",
        width: 500,
        height: 600,
        cancelVisible: true,
        cancelText: '关闭',
        template: '<swb-plan-yq-info-for-batch :planType="planType" ref="swb_plan_yq_for_batch_info"></swb-plan-yq-info-for-batch>',
        data: {
            planType: params.planType
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_plan_yq_for_batch_info.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

// 资产折旧
export function setAssetDeprCompDlg(callback) {
    let theDlg = Vue.$showDialog({
        title: "资产 - 折旧",
        width: 600,
        height: 450,
        cancelVisible: true,
        cancelText: '关闭',
        template: '<swb-asset-depr-comp ref="swb_asset_depr_comp"></swb-asset-depr-comp>',
        data: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_asset_depr_comp.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

// 资产明细编辑
export function shopDeviceEditInfoDlg(params, callback) {
    let theDlg = Vue.$showDialog({
        title: "资产明细 - 编辑",
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelVisible: false,
        template: '<swb-shop-device-edit-info-dlg :deviceSubNoId="deviceSubNoId" :tmpNo="tmpNo" ref="swb_shop_device_edit_info_dlg"></swb-shop-device-edit-info-dlg>',
        data: {
            deviceSubNoId: params.id,
            tmpNo: params.tmpNo
        },
        methods: {},
        okClicked: function () {
        },
        onClosed: function () {
            callback();
        }
    });
}

// 资产快捷操作【报废、清理】
export function assetQuickOptionDlg(params, callback) {
    let theDlg = Vue.$showDialog({
        title: "资产明细 - 快捷操作",
        width: 600,
        height: 400,
        showCloseBtn: true,
        okVisible: false,
        cancelVisible: false,
        template: '<swb-asset-quick-option :id="id" :title="title" :batchFlag="batchFlag" :inStkAvQuantity="inStkAvQuantity" :inStkNvQuantity="inStkNvQuantity" :scrapped="scrapped" :cleared="cleared" :clearCause="clearCause" @refreshChang="refreshChang" ref="swb_asset_quick_option"></swb-asset-quick-option>',
        data: {
            id: params.id,
            title: params.title,
            batchFlag: params.batchFlag,
            scrapped: params.scrapped,
            cleared: params.cleared,
            clearCause: params.clearCause,
            inStkAvQuantity: params.inStkAvQuantity,
            inStkNvQuantity: params.inStkNvQuantity,
            needRefresh: false
        },
        methods: {
            refreshChang: function (needRefresh) {
                this.needRefresh = needRefresh;
            }
        },
        okClicked: function () {
        },
        onClosed: function () {
            callback();
        }
    });
}

// 资产档案记录
export function assetCaseRecordDlg(params, callback) {
    let theDlg = Vue.$showDialog({
        title: "资产明细 - 档案记录",
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelVisible: false,
        template: '<swb-asset-case-record-dlg :deviceSubNoId="deviceSubNoId" :durable="durable" :toServcWork="toServcWorkTmp" ref="swb_asset_case_record_dlg"></swb-asset-case-record-dlg>',
        data: {
            deviceSubNoId: params.deviceSubNoId,
            durable: params.durable
        },
        methods: {
            toServcWorkTmp(routerObj){
                theDlg.close();
                params.toServcWork(routerObj);
            }
        },
        okClicked: function () {
        },
        onClosed: function () {
        }
    });
}

import SwbGoodsCategAndBrandSelect from './GoodsCategAndBrandSelect'
Vue.regist(SwbGoodsCategAndBrandSelect);
// 资产档案记录
export function GoodsCategAndBrandSelectDlg(params, callback) {
    let theDlg = Vue.$showDialog({
        title: "分类品牌-选择",
        width: 1000,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-goods-categ-and-brand-select ref="swb_goods_categ_and_brand_select"></swb-goods-categ-and-brand-select>',
        data: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_goods_categ_and_brand_select.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        onClosed: function () {

        }
    });
}

import SwbAdoptedDeviceSave from './AdoptedDeviceSave'
Vue.regist(SwbAdoptedDeviceSave);
// 资产档案记录
export function adoptedDeviceSaveDlg(params, callback) {
    let id = params["id"] || null;
    let title = Utils.isNoB(id) ? "入选商品 - 新增" : "入选商品 - 修改";
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-adopted-device-save :id="id" ref="swb_adopted_device_save"></swb-adopted-device-save>',
        data: {
            id: id
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_adopted_device_save.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        onClosed: function () {

        }
    });
}

import SwbServcCategAndBrandSelect from './ServcCategAndBrandSelect'
Vue.regist(SwbServcCategAndBrandSelect);
// 资产档案记录
export function servcCategAndBrandSelectDlg(params, callback) {
    let theDlg = Vue.$showDialog({
        title: "分类品牌-选择",
        width: 1000,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-servc-catg-and-brand-select ref="swb_servc_catg_and_brand_select"></swb-servc-catg-and-brand-select>',
        data: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_catg_and_brand_select.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        onClosed: function () {

        }
    });
}

import SwbAdoptedServcSave from './AdoptedServcSave'
Vue.regist(SwbAdoptedServcSave);
// 资产档案记录
export function adoptedServcSaveDlg(params, callback) {
    let id = params["id"] || null;
    let title = Utils.isNoB(id) ? "入选服务 - 新增" : "入选服务 - 修改";
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-adopted-servc-save :id="id" ref="swb_adopted_servc_save"></swb-adopted-servc-save>',
        data: {
            id: id
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_adopted_servc_save.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        onClosed: function () {
        }
    });
}
import SwbGoodsInSelect from './GoodsInSelect'
Vue.regist(SwbGoodsInSelect);
// 资产档案记录
export function goodsInSelectDlg(params, callback) {
    let centBuyMode = params["centBuyMode"] != null ? params["centBuyMode"] : null;
    let skuFlag = params["skuFlag"] ? params["skuFlag"] : null;
    let checkIds = params["checkIds"] || [];
    let catId = params["catId"] || null;
    let title = params["title"] || "入选商品 - 选择";
    let brandId = params["brandId"] || null;
    let fixedSpec = params["fixedSpec"] || null;
    let model = params["model"] || null;
    let filter = params["filter"] || {};
    let checkBox = params["checkBox"] != null ? params["checkBox"] : true;
    let showTable = params["showTable"] != null ? params["showTable"] : null;
    let showCatTable = params["showCatTable"] != null ? params["showCatTable"] : null;
    let showCatBrandTable = params["showCatBrandTable"] != null ? params["showCatBrandTable"] : null;
    let showCatBrandModelTable = params["showCatBrandModelTable"] != null ? params["showCatBrandModelTable"] : null;
    let showCatBrandModelFixedSpecTable = params["showCatBrandModelFixedSpecTable"] != null ? params["showCatBrandModelFixedSpecTable"] : null;
    let showAccFlag = params["showAccFlag"] != null ? params["showAccFlag"] : null;
    let showCentBuyFlag = params["showCentBuyFlag"] != null ? params["showCentBuyFlag"] : null; // 显示自采和集采页签
    let lowCostFlag = params["lowCostFlag"] != null ? params["lowCostFlag"] : null; // 显示自采和集采页签
    let contractEnded = params["contractEnded"] != null ? params["contractEnded"] : null; // 是否合同已结束
    let theDlg = Vue.$showDialog({
        title: title,
        width: -400,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-adopted-device-list-select :showCentBuyFlag="showCentBuyFlag" :showAccFlag="showAccFlag" :checkBox="checkBox" :showTable="showTable" :showCatBrandModelFixedSpecTable="showCatBrandModelFixedSpecTable" :showCatBrandModelTable="showCatBrandModelTable" :showCatTable="showCatTable" :showCatBrandTable="showCatBrandTable" :catId="catId" :brandId="brandId" :fixedSpec="fixedSpec" :model="model" :centBuyMode="centBuyMode" :skuFlag="skuFlag" :checkIds="checkIds" :filter="filter" :lowCostFlag="lowCostFlag" ref="swb_adopted_device_list_select"></swb-adopted-device-list-select>',
        data: {
            centBuyMode: centBuyMode,
            skuFlag: skuFlag,
            checkIds: checkIds,
            filter: filter,
            catId: catId,
            brandId: brandId,
            fixedSpec: fixedSpec,
            model: model,
            showTable: showTable,
            showCatBrandTable: showCatBrandTable,
            showCatTable: showCatTable,
            showCatBrandModelTable: showCatBrandModelTable,
            showCatBrandModelFixedSpecTable: showCatBrandModelFixedSpecTable,
            checkBox: checkBox,
            showAccFlag: showAccFlag,
            showCentBuyFlag: showCentBuyFlag,
            lowCostFlag: lowCostFlag,
            contractEnded: contractEnded
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_adopted_device_list_select.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        onClosed: function () {
        }
    });
}
import SwbGoodsInSelectGroup from './GoodsInSelectGroup'
Vue.regist(SwbGoodsInSelectGroup);
export function goodsInSelectGroupDlg(params, callback) {
    let checkIds = params["checkIds"] || [];
    let radio = params["radio"] || null;
    let filter = params["filter"];
    filter = filter == null ? {} : filter;
    let theDlg = Vue.$showDialog({
        title: "入选商品 - 选择",
        width: -200,
        height: -100,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-adopted-device-list-select-group :checkIds="checkIds" :radio="radio" :filter="filter" ref="swb_adopted_device_list_select"></swb-adopted-device-list-select-group>',
        data: {
            checkIds: checkIds,
            radio: radio,
            filter: filter
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_adopted_device_list_select.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        onClosed: function () {
        }
    });
}

import SwbServcInSelect from './ServcInSelect'
Vue.regist(SwbServcInSelect);
// 资产档案记录
export function servcInSelectDlg(params, callback) {
    let checkIds = params["checkIds"] || [];
    let theDlg = Vue.$showDialog({
        title: "入选服务 - 选择",
        width: 1000,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-adopted-servc-list-select  :checkIds="checkIds" ref="swb_adopted_servc_list_select"></swb-adopted-servc-list-select>',
        data: {
            checkIds: checkIds,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_adopted_servc_list_select.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        onClosed: function () {
        }
    });
}

import SwbDeviceRequireVoucherUpdate from './DeviceRequireVoucherUpdate'
Vue.regist(SwbDeviceRequireVoucherUpdate);
// 请购单审核的时候修改信息
export function deviceRequireVoucherUpdateDlg(params, callback) {
    let id = params["id"] || null;
    let auditDesc = params["auditDesc"] || null;
    let autoOrderFlag = params["autoOrderFlag"];
    let theDlg = Vue.$showDialog({
        title: "请购单审核 - 调整",
        width: -200,
        height: -100,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-device-require-voucher-update :id="id" :auditDesc="auditDesc" :autoOrderFlag="autoOrderFlag" ref="swb_device_require_voucher_update"></swb-device-require-voucher-update>',
        data: {
            id: id,
            auditDesc: auditDesc,
            autoOrderFlag: autoOrderFlag
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_device_require_voucher_update.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData, theDlg);
            } else {
                MsgBox.warning(result.message);

            }
            return false;
        },
        onClosed: function () {

        }
    });
}
import SwbRequireGoodsItemStatis from './RequireGoodsItemStatis'
Vue.regist(SwbRequireGoodsItemStatis);
// 请购单审核的时候修改信息
export function requireGoodsItemStatisDlg(params, callback) {
    let voucherIds = params["voucherIds"] || [];
    let lowCostFlag = params["lowCostFlag"] != null ? params["lowCostFlag"] : false; // 选择耗材信息
    let theDlg = Vue.$showDialog({
        title: "集中采购 - 下单",
        width: -400,
        height: 900,
        cancelVisible: true,
        okText: "下单",
        okVisible: true,
        template: '<swb-require-goods-item-statis :voucherIds="voucherIds" :lowCostFlag="lowCostFlag" ref="swb_require_goods_item_statis"></swb-require-goods-item-statis>',
        data: {
            voucherIds: voucherIds,
            lowCostFlag: lowCostFlag,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_require_goods_item_statis.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData, theDlg);
            } else {
                MsgBox.warning(result.message);

            }
            return false;
        },
        onClosed: function () {

        }
    });
}

import SwbAssetFiscalInfo from './AssetFiscalInfo';
Vue.regist(SwbAssetFiscalInfo);
// 资产详情
export function assetFiscalInfoDlg(params) {
    let theDlg = Vue.$showDialog({
        title: "资产 - 详情",
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-assert-fiscal-info :innerCode="innerCode" :assetType="assetType" ref="swb_assert_fiscal_info"></swb-assert-fiscal-info>',
        data: {
            innerCode: params.innerCode,
            assetType: params.assetType
        },
        methods: {
        },
        okClicked: function () {
        },
        onClosed: function () {
        }
    });
}

import SwbAssetSplitInfo from './AssetSplitInfo';
Vue.regist(SwbAssetSplitInfo);
// 资产拆分
export function assetSplitInfoDlg(assetInfo, callback) {
    let theDlg = Vue.$showDialog({
        title: "资产 - 拆分",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: true,
        template: '<swb-asset-split-info :assetInfo="assetInfo" ref="swb_assert_split_info"></swb-asset-split-info>',
        data: {
            assetInfo: assetInfo
        },
        methods: {
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_assert_split_info.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        onClosed: function () {
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/retailer/dialog.js
// module id = 26
// module chunks = 0